import { render, staticRenderFns } from "./admin-product-item.vue?vue&type=template&id=d187411e&scoped=true&"
import script from "./admin-product-item.vue?vue&type=script&lang=js&"
export * from "./admin-product-item.vue?vue&type=script&lang=js&"
import style0 from "./admin-product-item.vue?vue&type=style&index=0&id=d187411e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d187411e",
  null
  
)

export default component.exports